import React from 'react';
import {
  PreferencesContentWrapper,
  PreferencesSection,
  PreferencesSectionDescription,
  PreferencesSectionLink,
  PreferencesSectionTitle,
} from '../PreferencesUI';
import JupyterIntegrationForm from './JupyterIntegrationForm';
import { IconWrapper, SvgIcon } from '../../../../components/Icon';

const JupyterIntegration = () => {
  return (
    <PreferencesSection>
      <PreferencesSectionTitle>
        <IconWrapper size={24}>
          <SvgIcon name="jupyter" />
        </IconWrapper>
        Jupyter Integration
      </PreferencesSectionTitle>
      <PreferencesContentWrapper>
        <JupyterIntegrationForm />
        <PreferencesSectionDescription>
          Kubit integrates with Jupyter notebooks, allowing users to directly
          query and analyze data using Python&apos;s powerful libraries for
          advanced analytics and custom visualizations. This integration
          enhances dynamic exploration and deeper insights from Kubit data.
          <div>
            <PreferencesSectionLink
              to="https://docs.kubit.ai/docs/jupyter-notebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Setup Instructions
            </PreferencesSectionLink>
          </div>
        </PreferencesSectionDescription>
      </PreferencesContentWrapper>
    </PreferencesSection>
  );
};

export default JupyterIntegration;
